import proj4 from "proj4";

export function getUtmProj([lon, lat]) {
  const zone = Math.floor((lon + 180) / 6) + 1;
  const hemi = lat >= 0 ? " +north" : " +south";
  return `+proj=utm +zone=${zone}${hemi} +datum=WGS84 +units=m +no_defs`;
}
